import { render, staticRenderFns } from "./CoBrandedPageLogoImage.vue?vue&type=template&id=458e5155&scoped=true&"
import script from "./CoBrandedPageLogoImage.vue?vue&type=script&lang=js&"
export * from "./CoBrandedPageLogoImage.vue?vue&type=script&lang=js&"
import style0 from "./CoBrandedPageLogoImage.vue?vue&type=style&index=0&id=458e5155&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458e5155",
  null
  
)

export default component.exports